export enum CarouselPictureType {
  Property,
  WorkOrder,
  MaintenanceRequest,
}
